import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_EMPLOYEE_TRANSACTION_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_EMPLOYEE_TRANSACTION_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_EMPLOYEE_TRANSACTION_LIST_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/employees/${id}/transactions`,
    method: 'GET',
  })
);

export default apiCall;
